import Drawer, { DrawerProps } from '@mui/material/Drawer';

interface RightDrawerProps extends Partial<DrawerProps> {
    width?: string | number
}

export const MuiRightDrawer = (props: RightDrawerProps) => {
    let { children, width = '60%', open, sx, ...others } = props;
    return (
        <Drawer
            open={open}
            transitionDuration={{ enter: 500, exit: 100 }}
            {...others}
            PaperProps={{
                sx: {
                    width: width,
                    boxSizing: 'border-box',
                    padding: 2,
                    minWidth: 300,
                    ...sx
                }
            }}
            anchor="right"
        >
            {open && children}
        </Drawer>
    );
}